// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';

import { Branding, BrandingOptions } from './components/common/Constants';
/*import './vame/vame.css';*/
import './sonnentherme/sonnentherme.css';
// ----------------------------------------------------------------------

export default function App() {

  document.getElementsByTagName("body")[0].classList.add(Branding);
 
  return (
 
      <ThemeConfig >
        <ScrollToTop />
        <GlobalStyles />
        <BaseOptionChartStyle />
        <Router />
      </ThemeConfig>

  );
}
